var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mparE"},[_c('div',{ref:"allmap",staticClass:"newmpar",attrs:{"id":"allmap"}}),_c('div',{staticClass:"info"},[_vm._v("点击地图上的点标记，打开所添加的自定义信息窗体")])])}
var staticRenderFns = []

export { render, staticRenderFns }